import React from 'react';

import { Footer } from '../shared-components/footer/footer';

import { CateringExperienceBanner } from '../catering/catering-banners/CateringExperienceBanner';
import { CateringTestimonialsSection } from '../catering/catering-testimonials/CateringTestimonialsSection';
import { CateringFaqSection } from '../catering/catering-faqs/CateringFAQSection';
import { CateringContactBanner } from '../catering/catering-banners/CateringContactBanner';
import { CateringLandingPackageSections } from './catering-landing-packages/CateringLandingPackageSections';
import { CateringLandingHero } from './catering-landing-hero/catering-landing-hero';

import FAQs from '../catering/catering-faqs/catering-landing-faqs.json';
import { CateringLandingStepsSection } from './catering-landing-steps/catering-landing-steps';
import { CateringLandingNavigationSection } from './catering-landing-navigation/catering-landing-navigation';

export const CateringLandingPage = () => {
  return (
    <div className="CateringLandingPage">
      <CateringLandingHero />

      <CateringLandingStepsSection />

      <CateringLandingNavigationSection />

      <CateringLandingPackageSections />

      <CateringExperienceBanner />

      <CateringTestimonialsSection />

      <CateringFaqSection FAQs={FAQs} />

      <CateringContactBanner />

      <Footer />
    </div>
  );
};
